<script>
    import {createEventDispatcher} from "svelte";
    import {_} from "svelte-i18n";

    const dispatch = createEventDispatcher();
</script>

<div on:click={() => dispatch("click")} class="button-row">
    <div class="headline-xs">{$_("next_hall")}</div>
    <img src="./images/icons/arrow.svg" alt={$_("next_hall")}/>
</div>

<style>
    .button-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 8px 0 32px 0;
        cursor: pointer;
    }
</style>
